module.exports = __webpack_public_path__ + "static/media/Push-Preview-Frame-Full.c69b4396.svg";